import { Group, Tooltip } from '@mantine/core';
import { ArrowsLeftRight } from '@phosphor-icons/react';
import type { FC } from 'react';

import { STOCK_TRANSFER_LABEL, STOCK_TRANSFER_TOOLTIP } from './stockTransfer.constants';

/**
 * Column header for Stock Transfer in every grid. The icon is the Stock Transfers page's own,
 * so the column reads as that page's figure.
 */
const StockTransferHeader: FC<{ tooltip?: string }> = ({ tooltip = STOCK_TRANSFER_TOOLTIP }) => (
    <Tooltip label={tooltip} multiline w={260} withArrow>
        <Group component="span" gap={4} wrap="nowrap">
            <ArrowsLeftRight size={12} weight="bold" aria-hidden />
            <span>{STOCK_TRANSFER_LABEL}</span>
        </Group>
    </Tooltip>
);

export default StockTransferHeader;
